/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Button from '../../common/Button';
import EmptyTableBase from './EmptyTableBase';
import { selectVersion } from '../../../redux/features/configuration/configuration.slice';
import { dataTestId } from '../../../shared/utils/versionUtils';

const useStyles = makeStyles({
  text: {
    margin: '0 0 2rem 0',
  },
});

export default function EmptyTableWithFilter({ className, icon, onClick }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const selectedVersion = useSelector(selectVersion);

  return (
    <EmptyTableBase className={className} icon={icon}>
      <Typography className={classes.title} variant="h2">
        {t('messages.submission.dont.have.filter')}
      </Typography>
      <p className={classes.text}>{t('submission.adjust.filter')}</p>
      <Button
        {...dataTestId({ value: `createSubmissionButton--${selectedVersion.value}` })}
        color="primary"
        onClick={onClick}
        disableElevation
      >
        {t('Clear')}
      </Button>
    </EmptyTableBase>
  );
}
